var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43752 9.58151L16.6238 2.22391C16.743 2.10306 16.8376 1.95929 16.9022 1.80088C16.9668 1.64247 17 1.47257 17 1.30096C17 1.12935 16.9668 0.959445 16.9022 0.801037C16.8376 0.642629 16.743 0.498855 16.6238 0.37801C16.3855 0.135897 16.0631 -4.09532e-08 15.7271 -5.5641e-08C15.3911 -7.03289e-08 15.0687 0.135897 14.8304 0.37801L8.47087 6.81266L2.17495 0.378009C1.93665 0.135896 1.61428 -6.72531e-07 1.27826 -6.87219e-07C0.942244 -7.01907e-07 0.619877 0.135896 0.381571 0.378009C0.261391 0.498402 0.165781 0.641972 0.100283 0.800402C0.0347843 0.958831 0.000699948 1.12897 -5.68668e-08 1.30096C0.000699933 1.47295 0.0347842 1.64309 0.100283 1.80152C0.165781 1.95995 0.261391 2.10352 0.381571 2.22391L7.56782 9.58151C7.68693 9.71346 7.83148 9.81877 7.99237 9.89079C8.15327 9.96282 8.32702 10 8.50267 10C8.67832 10 8.85207 9.96282 9.01297 9.89079C9.17386 9.81877 9.31842 9.71346 9.43752 9.58151Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.e563544f7899a3b8707c094e9fd0cc99.svg";
export { ForwardRef as ReactComponent };